import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { COMMON_MESSAGES } from 'src/app/messages';

@Component({
  selector: 'app-upload-button',
  templateUrl: './upload-button.component.html',
  styleUrls: ['./upload-button.component.scss']
})
export class UploadButtonComponent implements OnInit {
  uploadTypes = {
    KEY: 'key',
    BASE64: 'base64'
  };

  fileName: string;
  fileNames = [];
  private fileTypesRegexp;
  @Input() componentId = 'file_upload';
  @Input() displayIconClass = 'upload-icon';
  @Input() cssOverrideClass = 'letterHeadStyle';
  @Input() displayText = 'Upload';
  @Input() uploadType = this.uploadTypes.BASE64;
  @Input() fileTypes = null;
  @Input() allowMultipleFiles = false;
  @Output() fileAsDataURL = new EventEmitter();

  constructor(
    private cd: ChangeDetectorRef,
    private toastr: ToastrService
  ) {}

  ngOnInit() {
    this.fileTypesRegexp = this.fileTypes && this.fileTypes.length ?
     new RegExp('(' + this.fileTypes.join('|').replace(/\./g, '\\.') + ')$') :
     null;
  }

  onFileChange(event) {

    if (this.allowMultipleFiles && event.target.files && event.target.files.length) {
      const files = event.target.files;
      const fileStreamList = [];
      let isFileTypeMismatch = true;

      for (let i = 0; i < files.length; i++) {
        this.fileNames.push(files[i].name);
        if (!files[i].name.toLowerCase().match(this.fileTypesRegexp)) {
          isFileTypeMismatch = isFileTypeMismatch && false;
        }
      }

      if (!isFileTypeMismatch) {
        this.toastr.warning(COMMON_MESSAGES.FILE_FORMATS_WARNING + this.fileTypes.join(','));
        this.fileNames = null;
        event.target.files = null;
        this.fileAsDataURL.emit(null);
      } else {
        for (let i = 0; i < files.length; i++) {
          const reader = new FileReader();
          reader.readAsDataURL(files[i]);
          reader.onload = () => {
            if (reader.result) {
              fileStreamList.push(reader.result);
              if (fileStreamList.length === files.length) {
                this.fileAsDataURL.emit(fileStreamList);
              }
            }
            // need to run CD since file load runs outside of zone
            this.cd.markForCheck();
          };
        }
      }



    } else if (!this.allowMultipleFiles && event.target.files && event.target.files.length) {
      const reader = new FileReader();
      const [file] = event.target.files;
      this.fileName = file.name;

      if (this.fileTypes) {
        if (!file.name.toLowerCase().match(this.fileTypesRegexp)) {
          this.toastr.warning(COMMON_MESSAGES.FILE_FORMATS_WARNING + this.fileTypes.join(','));
          this.fileName = null;
          event.target.files = null;
          this.fileAsDataURL.emit(null);
          return;
        }
      }

      if (this.uploadTypes[this.uploadType] === this.uploadTypes.KEY) {
        this.fileAsDataURL.emit(file);
      } else {
        reader.readAsDataURL(file);
        reader.onload = () => {
          if (reader.result) {
            this.fileAsDataURL.emit(reader.result);
          }
          // need to run CD since file load runs outside of zone
          this.cd.markForCheck();
        };
      }

    }
  }
}
